export default __webpack_public_path__ + "static/media/Mountan.b37d7d5c.png";